<template lang="pug">
  .container-reg-done
    el-steps(align-center).reg-steps
      el-step(title="填写账号密码", status="success")
      el-step(title="完善商家资料", status="success")
      el-step(title="绑定联系方式", status="success")
    h2.align-center 注册成功
    .reg-form-button-group
      el-button(type="primary", @click="next").reg-button 立即进入
</template>

<script>
export default {
  computed: {
    register_key () {
      return this.$store.getters.register_key;
    },
  },
  methods: {
    next () {
      const query = this.register_key ? `?register_key=${this.register_key}` : '';
      // debugger
      window.location.replace(`/mch_web/v1/complete_register${query}`);
    },
  },
};
</script>

